import React from "react";
import { TableCell, TableRow, Link } from "@material-ui/core";
import {
  DPBatchDisbursement,
  DisbursementStatus,
  disbursementStatusDictionary,
} from "Shared/types/Disbursements";
import pretty from "Shared/pretty";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import { BatchDisbursementActions } from "./BatchDisbursementActions/BatchDisbursementActions";
import useStyles from "./styles";
import { DPEmployer } from "Shared/types/PartnerConfig";

export function canApproveDisbursementFile(
  disbursement: DPBatchDisbursement,
  employer: DPEmployer
) {
  return (
    employer.id !== disbursement.requester.id &&
    disbursement.status === DisbursementStatus.pendingApproval
  );
}

export const BatchDisbursementRow = (disbursement: DPBatchDisbursement) => {
  const {
    id,
    createdAt,
    requester,
    originalFilename,
    status,
    attachment,
    errorsAttachment,
  } = disbursement;
  const classes = useStyles({ status });
  const { employer } = usePartnerConfig();

  const canApprove = canApproveDisbursementFile(disbursement, employer);

  const onRefreshClick = () => {
    window.location.reload();
  };

  return (
    <TableRow>
      <TableCell>
        {pretty.date(createdAt, { withTime: true })}
      </TableCell>
      <TableCell>
        {pretty.fullName(requester.firstName!, requester.lastName!)}
      </TableCell>
      <TableCell className={classes.filename}>
        {originalFilename}
      </TableCell>
      <TableCell className={classes.status}>
        {disbursementStatusDictionary[status as DisbursementStatus]}
      </TableCell>
      <TableCell>
        {
          attachment?.url && (
            <Link href={attachment?.url} target="blank">
              View
            </Link>
          )
        }
      </TableCell>
      <TableCell>
        {
          errorsAttachment?.url ? (
            <Link href={errorsAttachment?.url} target="blank">
              View
            </Link>
          ) : (
            <Link onClick={onRefreshClick}>
              Refresh
            </Link>
          )
        }
      </TableCell>
      <TableCell align="center">
        {canApprove && (
          <BatchDisbursementActions batchDisbursementId={id} />
        )}
      </TableCell>
    </TableRow>
  );
};
